import { render, staticRenderFns } from "./personMerge.modal.vue?vue&type=template&id=b2ff9e60&scoped=true"
import script from "./personMerge.modal.vue?vue&type=script&lang=js"
export * from "./personMerge.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ff9e60",
  null
  
)

export default component.exports